import React from 'react'
import WrapperReactPage from '../General/WrapperReactPage'
import FilterResultsMovie from '../Overview/FilterResultsMovie'
import OverviewHero from './OverviewHero'
import MainSliderWrapper from '../PageFrontOverview/MainSliderWrapper'
import hasCloseEverythingIfNotActiveSelection from '../hoc/hasCloseEverythingIfNotActiveSelection'
import FilterResultsMovieArthouse from '../Overview/FilterResultsMovieArthouse'
import TrailerPopupWrapper from '../Trailer/TrailerPopupWrapper'

const PageOverviewMovie = ({
    match, 
    movies, 
    routesData,
    weischerAds,
    advertisements,
    elbenwald,
    overviewHeroItems, 
    overviewHeroAdvertisementItems,
    features, 
    programOverviewListStyle,
    headerAppearance,
    contentWidth,
    attributeStyling,
    hiddenAttributes,
    detailsStyling,
    posterStyling,
    theme,
    overviewSubtitle,
    translation,
    stripeAppearance,
    location,
    isOverviewPage,
    isScrolledClass,
    ignoreAttributesForPerformanceFilter,
    itemSelectionsDisplay,
    itemSelections,
    showAvailableIn,
    itemCollections,
    isConnectedFast,
    hasChatbot,
    sliderAppearance,
    mainSliderAdvertisementPositioning,
    currentActiveSelection,
    setIdForActiveSelection,
    informationStyling,
    ads
}) => (
    theme === 'Arthouse' ? (
        <WrapperReactPage hasChatbot={hasChatbot} headerAppearance={headerAppearance} features={features} contentWidth={contentWidth} advertisements={advertisements} isScrolledClass={isScrolledClass} movies={movies} translation={translation}>
             {movies && movies.items && <FilterResultsMovieArthouse
                match={match}
                overviewSubtitle={overviewSubtitle}
                movies={movies}
                location={location}
                hiddenAttributes={hiddenAttributes}
                detailsStyling={detailsStyling}
                informationStyling={informationStyling}
                attributeStyling={attributeStyling}
                programOverviewListStyle={programOverviewListStyle}
                stripeAppearance={stripeAppearance}
                routesData={routesData}
                weischerAds={weischerAds}
                ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
                advertisements={advertisements}
                posterStyling={posterStyling}
                theme={theme}
                translation={translation}
                moviesRoutesData={routesData.movies.items}
            />}
            <TrailerPopupWrapper/>
        </WrapperReactPage>
    ) : (
        <WrapperReactPage hasChatbot={hasChatbot} headerAppearance={headerAppearance} features={features} contentWidth={contentWidth} advertisements={advertisements} isScrolledClass={isScrolledClass} movies={movies} translation={translation}>
            {movies && isOverviewPage && <MainSliderWrapper
                itemSelectionsDisplay={itemSelectionsDisplay}
                sliderAppearance={sliderAppearance}
                attributeStyling={attributeStyling}
                showAvailableIn={showAvailableIn}
                mainSliderAdvertisementPositioning={mainSliderAdvertisementPositioning}
                itemSelections={itemSelections}
                itemCollections={itemCollections}
                hiddenAttributes={hiddenAttributes}
                informationStyling={informationStyling}
                detailsStyling={detailsStyling}
                ads={ads}
                advertisements={advertisements}
                weischerAds={weischerAds}
                elbenwald={elbenwald}
                movies={movies.items}
                theme={theme}
                moviesRoutesData={routesData.movies.items}
                translation={translation}
                currentActiveSelection={currentActiveSelection}
                setIdForActiveSelection={setIdForActiveSelection}
                features={features}
                isConnectedFast={isConnectedFast}
            />}
            {!isOverviewPage && <OverviewHero
                overviewHeroItems={overviewHeroItems}
                overviewHeroAdvertisementItems={overviewHeroAdvertisementItems}
                features={features}
                movies={movies}
            />}
            {movies && movies.items && <FilterResultsMovie
                match={match}
                overviewSubtitle={overviewSubtitle}
                movies={movies}
                detailsStyling={detailsStyling}
                location={location}
                attributeStyling={attributeStyling}
                stripeAppearance={stripeAppearance}
                routesData={routesData}
                informationStyling={informationStyling}
                programOverviewListStyle={programOverviewListStyle}
                weischerAds={weischerAds}
                advertisements={advertisements}
                hiddenAttributes={hiddenAttributes}
                posterStyling={posterStyling}
                theme={theme}
                translation={translation}
            />}
            <TrailerPopupWrapper/>
        </WrapperReactPage>
    )
)

export default hasCloseEverythingIfNotActiveSelection(PageOverviewMovie)

